import PropTypes from 'prop-types';
import React from 'react';

import { DIMENSIONS } from 'components/CollectionLifestyleCard';
import PlaceholderCard from 'components/CustomCollectionProductCard/PlaceholderCard';
import { Small, MediumUp } from 'components/MediaQuery';
import { COLLECTION_COLORWAY_PICKER_APPEARANCES } from 'constants/collectionPage';
import { largeUp, mediumUp } from 'constants/mediaQueries';
import CollectionMasterProductCardContainer from 'containers/CollectionMasterProductCardContainer';
import Theme from 'styles/theme';

import ChildNamePlaceholder from './ChildNamePlaceholder';

const CollectionChild = ({
  handle,
  isEmpty,
  isLoading,
  initialColorwayHandle,
  hasMobileQuickAddRow,
  ...otherProps
}) => {
  if (isEmpty && !isLoading) {
    return null;
  }

  return (
    <div className="CollectionChild">
      {isLoading ? (
        <>
          <div className="CollectionChild__name-placeholder">
            <ChildNamePlaceholder />
          </div>
          <PlaceholderCard />
        </>
      ) : (
        <>
          <Small>
            <CollectionMasterProductCardContainer
              masterHandle={handle}
              initialColorwayHandle={initialColorwayHandle}
              hasMobileQuickAddRow={hasMobileQuickAddRow}
              appearance={COLLECTION_COLORWAY_PICKER_APPEARANCES.COLOR_SWATCHES}
              nItemsPerSlide={4}
              {...otherProps}
            />
          </Small>
          <MediumUp>
            <CollectionMasterProductCardContainer
              masterHandle={handle}
              initialColorwayHandle={initialColorwayHandle}
              hasMobileQuickAddRow={hasMobileQuickAddRow}
              appearance={COLLECTION_COLORWAY_PICKER_APPEARANCES.THUMBNAILS}
              {...otherProps}
            />
          </MediumUp>
        </>
      )}

      <style jsx>
        {`
          .CollectionChild {
            padding: 0;
            height: 100%;
          }

          .CollectionChild__name {
            margin-bottom: ${Theme.get('spacing') * 2}px;
          }

          .CollectionChild__cards {
            display: flex;
          }

          .CollectionChild--v2:not(.CollectionChild--v2-size-selector) {
            height: 100%;
          }

          .CollectionChild__product-card,
          .CollectionChild__lifestyle-card {
            flex: 1;
            width: 50%;
            min-width: ${DIMENSIONS.TABLET_WIDTH}px;
          }

          .CollectionChild__product-card {
            padding-right: ${Theme.get('spacing') * 4}px;
          }

          @media ${mediumUp} {
            .CollectionChild {
              height: ${!hasMobileQuickAddRow ? '100%' : 'auto'};
            }

            .CollectionChild__name {
              min-height: ${Theme.get('spacing') * 12}px;
            }
          }
          @media ${largeUp} {
            .CollectionChild__name,
            .CollectionChild__name-placeholder {
              display: none;
            }
          }
        `}
      </style>

      <style jsx global>
        {`
          .CollectionChild--v2:not(.CollectionChild--v2-size-selector) .ShadowBox {
            display: flex;
            flex-direction: column;
            height: 100%;
          }
        `}
      </style>
    </div>
  );
};

CollectionChild.propTypes = {
  handle: PropTypes.string,
  hasMobileQuickAddRow: PropTypes.bool,
  isEmpty: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  initialColorwayHandle: PropTypes.string,
};

CollectionChild.defaultProps = {
  handle: null,
  hasMobileQuickAddRow: false,
  isLoading: false,
  initialColorwayHandle: null,
};

export default CollectionChild;
